import React, { Component } from "react";

import PropTypes from "prop-types";

import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import { auth, storage, firestore, analytics } from "../firebase";

import { Box, Typography, Grid, GridItem, Divider, LinearProgress } from "@material-ui/core";
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import RefreshIcon from '@material-ui/icons/Refresh'

import Drawer from '@material-ui/core/Drawer';

import Loader from "../components/Loader"
import moment from "moment";

import BaseList from "./components/BaseList";
import BaseForm from "./components/BaseForm";
import BaseFilter from "./components/BaseFilter";
import BaseToolbar from "./components/BaseToolbar";
import BaseCard from "./components/BaseCard";
import * as RFIcon from 'react-feather'; 
import BaseSidePanel from "./components/BaseSidePanel";
import language from "../languages";
import BaseMap from "./components/BaseMap";

const styles = (theme) => ({
    filterGrid: {
        minHeight: '100vh',
        backgroundColor: '#F3F6FF',
    },
    divider: {
        backgroundColor:"#2735A4",
        height: 2
    },
    displayToggleArea: {
        display: 'flex',
        float: 'right'
    },
    toggleIcon: {
        color: '#000000',
        marginLeft: theme.spacing(2),
        cursor: 'pointer'
    }
});

class BasePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formShown: false,
            loading: true,
            rows: [],
            currentRowId: null,
            currentRow: null,
            filterObj: [],
            selectInputItems: {},
            searchTerms: [],
            onlyForm: true,
            itemsPerPage: props.meta.itemsPerPage || 12,
            lastRowRef: null,
            firstRowRef: null,
            showFilterObj: false,
            displayToggleType: props.meta.displayType,
            toggleSidePanel: false,
            sidePanelDetail: {},
            pager: {
                itemsPerPage: props.meta.itemsPerPage || 12,
                totalCount: 10,
                pageNo: 0
            },
            isCsvUploading: false,
            csvUploadingProgress: 0, 
            csvUploadingCount: 0,
            csvUploadingCountTotal: 0
        }
    }

    async componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.meta.entityName != this.props.meta.entityName) {
            this.init()
        }
    }

    init = async () => {
        const { meta } = this.props;
        const onlyForm = (meta.card || meta.table) ? false : true;
        this.setState({ onlyForm: onlyForm, currentRowId: meta.docPath })

        this.refresh();
        this.initFilter();
        this.initSelectInputItems();
    }

    initFilter = async () => {
        const { meta } = this.props;
        if(meta.filterObject){
            let newFilterObj = meta.filterObject.map(item=>item);
            //process Items
            for(let filterRow of newFilterObj){
                const keys = Object.keys(filterRow);
                for(let key of keys){
                    let value = filterRow[key];
                    if(key == 'items'){
                        if(typeof filterRow.items == 'function')
                            value = await filterRow.items(); 
                    }
                    filterRow[key] = value;
                }
            }
            this.setState({ filterObj: newFilterObj, searchTerms: [] })
        }
    }

    initSelectInputItems = async () => {
        const { meta } = this.props;
        if(meta.fields){
            let newSelectInputItems = {};
            //process Items

            // meta.fields.map((metaField, i) => {
            for(let metaField of meta.fields){
                if(metaField.input === 'multiselect' || metaField.input === 'select' || metaField.input === 'autocomplete'){
                    if(typeof metaField.getItems == 'function')
                        newSelectInputItems[metaField.name] = await metaField.getItems();
                }
            }
            this.setState({ selectInputItems: newSelectInputItems })
        }
    }

    refresh = async (paginationAction) => {
        const { meta, openSnackbar } = this.props;
        const onlyForm = (meta.card || meta.table) ? false : true;
        if(onlyForm){
            return;
        }
        this.setState({loading: true});
        if(onlyForm){
            meta.getQuery().get().then((doc)=> {
                const id = doc.id;
                const data = doc.data()
                this.setState({row: {id, ...data}});
                this.setState({ loading: false })
            }).catch((err)=> {
                openSnackbar('Error Loading ' + meta.entityName, 'error');
                this.setState({ loading: false })
            })
        } else {
            const { searchTerms, rows, itemsPerPage, lastRowRef, firstRowRef, pager } = this.state;
            const filter = this._getFilterCriteria();
            if(!paginationAction) {
                let newPager = {};
                newPager = Object.assign(pager, {pageNo: 0});
                this.setState({pager: newPager})
            }
            const totalCount = await this.getTotalItems()
            // console.log(pager)
            meta.getQuery(paginationAction, firstRowRef, lastRowRef, filter, 
                          searchTerms, meta.defaultOrderBy, itemsPerPage).get().then(async(querySnapshot) => {
                let docs = [];
                let lastRef = null;
                let firstRef = null;
                let index = 0;
                for(let i=0; i<querySnapshot.docs.length; i++){
                    const doc = querySnapshot.docs[i]
                    const id = doc.id;
                    let data = doc.data()
                    meta.fields.filter(field => field.dataType == 'timestamp').forEach(field => {
                        if(data[field.name]){
                            data[field.name] = moment.unix(data[field.name]).format('YYYY-MM-DD HH:mm');
                        }
                    })
                    if(meta.transform){
                        data = await meta.transform(data, id);
                    }
                    docs.push({ id, ...data })
                    lastRef = doc;
                    if(index == 0){
                        firstRef = doc
                    }
                    index++
                }
                this.setState({ loading: false })
                if (docs && docs.length > 0) {
                    let newRows = [];
                    if(paginationAction == 'next'){
                        newRows = rows.concat(docs)
                    } else {
                        newRows = docs;
                    }
                    this.setState({ rows: newRows, lastRowRef: lastRef, firstRowRef: firstRef})
                    analytics.logEvent(meta.collection + '_loaded', {
                        source: 'web'
                    });
                } else {
                    if(paginationAction == null){
                        this.setState({rows: [], lastRowRef: null, firstRowRef: null});
                    }
                    openSnackbar('No More Items to Load');
                }
            }).catch((error) => {
                debugger;
                console.log(error);//for index errors purposes
                this.setState({ loading: false })
                openSnackbar('Error Loading ' + meta.entityName, 'error');
            });   
        }
    }

    getTotalItems = () => {
        const { meta } = this.props;
        const { pager } = this.state;
        let tempPager = pager
        return new Promise((resolve, reject) => {
            const query = firestore.collection('_meta').doc(meta.collection)
            query.get().then((metaDoc)=> {
                if(metaDoc && metaDoc.data() && metaDoc.data().count){
                    tempPager.totalCount = metaDoc.data().count
                    this.setState({pager: tempPager}, 
                        () => { resolve(metaDoc.data().count) }
                    )
                }else{
                    resolve(0)
                }
                
            }).catch((err)=> {
                reject(err)
                console.log(err)
                // openSnackbar("Error getting Count", 'error');
            })
        })
    }

    onAdd = () => {
        const { meta, history } = this.props;
        if(meta.createLink){
            const url = meta.createLink;
            history.push(url);
        } else {
            this.setState({
                currentRowId: null
            });
            this.showForm()
        }
    }

    onNext = () => {
        this.refresh('next')
    }

    showForm = () => {
        this.setState({ formShown: true })
    }

    hideForm = () => {
        this.setState({ formShown: false })
    }

    

    onEdit = (doc) => {
        const { meta, history } = this.props;
        if(meta.editLink){
            const url = meta.editLink.replace(':id', doc.id);
            // debugger;
            history.push(url);
        } else {
            this.setState({ currentRowId: doc.id, currentRow: doc });
            this.setState({toggleSidePanel: false, sidePanelDetail: {}})
            this.showForm()
        }
        
    }

    onView = (doc) => {
        const { meta, history } = this.props;
        if(meta.viewLink){
            const url = meta.viewLink.replace(':id', doc.id);
            // debugger;
            if(meta.viewQuery) {
                history.push({
                    pathname: url,
                    search: meta.viewQuery(doc)
                })
            } else {
                history.push(url);
            }
        }
        
    }

    onDelete = (doc) => {
        const { meta, openSnackbar } = this.props;
        if (doc.id) {
            this.setState({loading: true});
            let ref = {};
            if(meta.getDeleteDocRef){
                ref = meta.getDeleteDocRef(doc)
            } else{
                ref = firestore.collection(meta.collection).doc(doc.id);
            }
            ref.delete().then(() => {
                this.setState({toggleSidePanel: false, sidePanelDetail: {}})
                openSnackbar(meta.entityName + ' deleted successfully', 'success')
                this.refresh()
                analytics.logEvent(meta.collection + '-deleted', {
                    source: 'web'
                })
                //Increment
                // debugger;
                const metaRef = firestore.collection('_meta').doc(meta.collection);
                firestore.runTransaction(function(transaction) {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(metaRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Count does not exist!";
                        }
                        var newCount = sfDoc.data().count - 1;
                        transaction.update(metaRef, { count: newCount });
                    });
                }).then(function() {
                    console.log("Count successfully Updated!");
                }).catch(function(error) {
                    console.log("Count update failed: ", error);
                });
                
                // metaRef.get().then((metaDoc)=> {
                //     // debugger;
                //     var newCount = metaDoc.data().count - 1;
                //     metaRef.update({'count': newCount}).then(() => {
                //         // debugger;
                //     }, err => {
                //         // debugger;
                //         openSnackbar("Error Updating Count", 'error');
                //     })
                // }).catch((err)=> {
                //     debugger;
                //     openSnackbar("Error Updating Count", 'error');
                // })
                // metaRef.doc(meta.collection).set({count: firestore.FieldValue.increment(-1)}).then(()=>{

                // }, err=>{
                //     openSnackbar("Error Updating Count", 'error');
                // })
            }, err => {
                this.setState({loading: false});
                openSnackbar('Delete Failed', 'error')
            })
        }
    }

    onSearch = (value) => {
        // const value = e.target.value;
        const {searchTerms} = this.state
        let searchTermsList = searchTerms
        searchTermsList.push(value)
        this.setState({ searchTerms: searchTermsList }, 
            () => {
                this.refresh()
            }
        )
        // if (value && (value.length > 2 || value.length == 0)) {
        //     this.refresh();
        // }
    }

    deleteSearchTerms = (value) => {
        const {searchTerms} = this.state
        let searchTermsList = searchTerms
        searchTermsList.splice(searchTermsList.indexOf(value), 1);
        this.setState({ searchTerms: searchTermsList }, 
            () => {
                this.refresh()
            }
        )
    }

    handleFilter = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const checked = e.target.checked;
        this.setState(state => {
            const filterIdx = state.filterObj.findIndex(section => section.name == name);
            const filter = state.filterObj[filterIdx];
            const idx = filter.items.findIndex(item => item.value === value);
            if (filter.type == 'checkbox') {
                filter.items[idx].selected = checked;
            } else if (filter.type == 'radio') {
                filter.items.map(item => item.selected = false);
                filter.items[idx].selected = checked;
            }
            return { filterObj: state.filterObj }
        }, () => this.doFilter())
    }

    //return [{attribute, opreration,value}]
    _getFilterCriteria = () => {
        let criteria = [];
        const { filterObj } = this.state;
        if (filterObj) {
            const singleOptions = filterObj.filter(filter => filter.type == 'radio');
            singleOptions.forEach(filter => {
                const selectedItem = filter.items.filter(item => item.selected == true);
                if (selectedItem.length > 0) {
                    criteria.push({
                        attribute: filter.name,
                        operation: '==',
                        value: filter.items.filter(item => item.selected == true)[0].value
                    })
                }
            });
            const multipleOptions = filterObj.filter(filter => filter.type == 'checkbox');
            multipleOptions.forEach(filter => {
                const multiValue = filter.items.filter(item => item.selected == true).map(item => item.value)
                if (multiValue.length > 0) {
                    criteria.push({
                        attribute: filter.name,
                        operation: 'in',
                        value: multiValue
                    })
                }
            })
        }

        return criteria;
    }

    doFilter = () => {
        this.refresh();
    }

    resetFilter = () => {
        const { filterObj } = this.state;
        if (filterObj) {
            filterObj.forEach(filter => {
                filter.items.map(item => item.selected = false);
            })
        }

        this.setState({ filterObj: filterObj, searchTerms: [] }, () => this.refresh())
        // this.refresh();
    }

    showFilterToggle = (value) => {
        this.setState({ showFilterObj: value})
    }

    setPageNumber = (newPageNo) =>{
        const { pager, rows } = this.state;
        let newPager = {};
        // debugger;
        const prevPageNo = pager.pageNo
        newPager = Object.assign(pager, {pageNo: newPageNo});
        this.setState({pager: newPager},
            () => {
                if(prevPageNo > newPageNo) {
                    // this.refresh('prev')
                }else if(prevPageNo < newPageNo) {
                    // if(rows.length < (pager.pageNo * pager.itemsPerPage + pager.itemsPerPage))
                    if(rows.length < pager.totalCount)
                        this.refresh('next')
                }
            }
        );
        // debugger;
    }

    setItemsPerPage = (newItemsPerPage) =>{
        const { pager } = this.state;
        let newPager = {};
        newPager = Object.assign(pager, {itemsPerPage: newItemsPerPage});
        this.setState({pager: newPager},
            () => { this.refresh() }
        );
    }

    showDetail = (doc) => {
        const { meta } = this.props;
        if(meta.displaySidePanel){
            this.setState({ toggleSidePanel: true, sidePanelDetail: doc });
        }
    }

    hideDetail = () => {
        const { meta } = this.props;
        if(meta.displaySidePanel){
            this.setState({ toggleSidePanel: false, sidePanelDetail: {} });
        }
    }

    uploadFromCsv = async(csvProducts) => {
        this.setState({loading: true});
        this.setState({isCsvUploading: true});
        const { user } = this.props;
        if(csvProducts.length > 1){
            this.setState({csvUploadingCountTotal: csvProducts.length});
            for(let i = 1; i < csvProducts.length; i++ ) {
                let newProduct = {}
                let vendorProduct = {}
                for(let j = 0; j < csvProducts[i].length; j++ ) {
                    if(["sellingPrice"].includes(csvProducts[0][j])) {
                        newProduct[csvProducts[0][j]] = Number(csvProducts[i][j])
                    } else if(["id"].includes(csvProducts[0][j])) {
                        newProduct[csvProducts[0][j]] = csvProducts[i][j]
                    }
                }
                if(newProduct.id) {
                    // vendorProduct.parentProduct = newProduct.id
                    // vendorProduct.id = user.uid
                    // vendorProduct.storeId = user.uid
                    // vendorProduct._createdOn = new Date().getTime()
                    vendorProduct._updatedOn = new Date().getTime()
                    // vendorProduct.maxQuantity = 12
                    vendorProduct.sellingPrice = newProduct.sellingPrice
                    vendorProduct._owner= {
                        id: user.uid,
                        displayName: user.displayName,
                        email: user.email
                    }
                    // vendorProduct.deals= []
                    // let parentProduct = await firestore.collection('products').doc(vendorProduct.parentProduct).get()
                    // vendorProduct._product = {uid: parentProduct.id, ... parentProduct.data()}
                    // debugger
                    let ref = firestore.collection('products').doc(newProduct.id).collection('vendors').doc(user.uid)
                    // await ref.set(newProduct)
                    const doc = await ref.get();
                    if (!doc.exists) {
                        vendorProduct.parentProduct = newProduct.id
                        vendorProduct.id = user.uid
                        vendorProduct.storeId = user.uid
                        vendorProduct._createdOn = new Date().getTime()
                        vendorProduct.maxQuantity = 12
                        vendorProduct.deals= []
                        let parentProduct = await firestore.collection('products').doc(newProduct.id).get()
                        vendorProduct._product = {uid: parentProduct.id, ... parentProduct.data()}
                        await ref.set(vendorProduct)
                    } else {
                        await ref.update(vendorProduct)
                    }
                } else {
                    console.log("product id is missing")
                }
                let progressPercent = (i/csvProducts.length)*100
                this.setState({csvUploadingProgress: progressPercent, csvUploadingCount: i});
            }
        }
        this.setState({isCsvUploading: false, csvUploadingProgress: 0, csvUploadingCount: 0, csvUploadingCountTotal: 0});
        this.setState({loading: false});
    }

    handleCustomAction = async(actionCode, doc) => {
        const {meta, user, openSnackbar} = this.props
        try{
            this.setState({loading: true});
            meta.customActions[actionCode].action(doc, user)
            .then((success) => {
                openSnackbar(success, 'success');
                this.refresh()
            })
            .catch((err) => {
                this.setState({loading: false});
                openSnackbar(err, 'error');
            })
        } catch(err) {
            // openSnackbar('Error Loading ' + meta.entityName, 'error');
            console.log(err)
            this.setState({loading: false});
        }
    }

    render() {
        const { user, theme, meta, openSnackbar, readOnly, classes, appSettings } = this.props;
        const { rows, row, filterObj, formShown, loading, searchTerms, onlyForm, currentRowId, currentRow, showFilterObj, 
                pager, selectInputItems, displayToggleType, toggleSidePanel, sidePanelDetail, 
                isCsvUploading, csvUploadingProgress, csvUploadingCount, csvUploadingCountTotal } = this.state;
        const lang = appSettings ? (appSettings.language ? appSettings.language: 'en') : 'en';

        let displayListType = null;
        const showFilter = (filterObj && filterObj.length > 0) ? true : false

        const tableRows =  (pager.itemsPerPage > 0
                ? rows.slice(pager.pageNo * pager.itemsPerPage, pager.pageNo * pager.itemsPerPage + pager.itemsPerPage)
                : rows
            )

        switch (meta.displayToggle ? displayToggleType : meta.displayType) {
            case 'card' :
                displayListType = <BaseCard meta={meta} rows={tableRows}
                    readOnly={readOnly}
                    lang = {lang}
                    pager={pager}
                    showFilter={(showFilter && showFilterObj) ? true : false }
                    setPageNumber={this.setPageNumber}
                    setItemsPerPage={this.setItemsPerPage}
                    onEdit={this.onEdit}
                    showDetail={this.showDetail}
                    sidePanelDetailId={sidePanelDetail.id}
                    onDelete={this.onDelete} />
                break;
            case 'map' :
                displayListType = <BaseMap meta={meta} rows={tableRows}
                    readOnly={readOnly}
                    lang = {lang}
                    pager={pager}
                    setPageNumber={this.setPageNumber}
                    setItemsPerPage={this.setItemsPerPage}
                    onEdit={this.onEdit}
                    onView={this.onView}
                    showDetail={this.showDetail}
                    sidePanelDetailId={sidePanelDetail.id}
                    onDelete={this.onDelete}
                    handleCustomAction={this.handleCustomAction} />
                break;
            case 'list' :
            default :
                displayListType = <BaseList meta={meta} rows={tableRows}
                    readOnly={readOnly}
                    lang = {lang}
                    pager={pager}
                    setPageNumber={this.setPageNumber}
                    setItemsPerPage={this.setItemsPerPage}
                    onEdit={this.onEdit}
                    onView={this.onView}
                    showDetail={this.showDetail}
                    sidePanelDetailId={sidePanelDetail.id}
                    onDelete={this.onDelete}
                    handleCustomAction={this.handleCustomAction} />
        }
        const toolbarComp = <BaseToolbar onRefresh={this.refresh} 
                                readOnly={readOnly}
                                lang = {lang}
                                onAdd={this.onAdd}
                                searchTerms={searchTerms}
                                title={meta.entityTitle ? meta.entityTitle : meta.entityName}
                                headerIcon={meta.headerIcon}
                                onSearch={this.onSearch}
                                deleteSearchTerms={this.deleteSearchTerms}
                                showFilterToggle={this.showFilterToggle}
                                showFilterOption={showFilter ? true : false}
                                isFilter={showFilterObj}
                                addButtonText={meta.addButtonText}
                                onlyForm={onlyForm}
                                settingsFields= {meta.settingsFields}
                                hideAddButton={meta.hideAddButton ? meta.hideAddButton : false}
                                hideTitle={meta.hideTitle ? meta.hideTitle : false }
                                filterObj = {filterObj}
                                handleFilter={this.handleFilter}
                                resetFilter={this.resetFilter}
                                uploadFromCsv={this.uploadFromCsv}
                                isUploadCsv={meta.isUploadCsv ? true : false}
                                getTitle={meta.getTitle ? meta.getTitle() : ''}
                                onNext={this.onNext}/>

        const gridComp = <Grid container>
            <Grid item xs={12}>
                {toolbarComp}
                <Divider className={classes.divider} />
            </Grid>
                {
                    showFilter && showFilterObj &&
                    <Grid item xs={12} md={2} className={classes.filterGrid} >
                        <BaseFilter filterObj={filterObj} 
                                        handleFilter={this.handleFilter}
                                        lang = {lang}
                                        doFilter={this.doFilter}
                                        showFilterToggle={this.showFilterToggle}
                                        resetFilter={this.resetFilter}/>
                    </Grid> 
                }
                

                <Grid item container xs={12} md={(showFilter && showFilterObj) ? 10 : 12 }>
                    <Grid item xs={12} md={toggleSidePanel ? 9 : 12 }>
                    <Box p={3} pr={toggleSidePanel ? 1 : 3}>
                        {loading ? <Loader /> : 
                            meta.displayToggle ?
                            <>
                                <Box className={classes.displayToggleArea}>
                                    <Typography variant="subtitle2" component="span" gutterBottom style={{color: '#09205C'}}>{language[lang].View} </Typography>
                                    {
                                        displayToggleType == 'list' ?
                                          meta.card ?
                                            <RFIcon.Grid className={classes.toggleIcon} strokeWidth={2} onClick={() => this.setState({displayToggleType: 'card'})} />
                                          : meta.map ?
                                                <RFIcon.Map className={classes.toggleIcon} strokeWidth={2} onClick={() => this.setState({displayToggleType: 'map'})} />
                                            : null
                                        :
                                            <RFIcon.List className={classes.toggleIcon} strokeWidth={2} onClick={() => this.setState({displayToggleType: 'list'})} />
                                    }
                                    
                                </Box>
                                {displayListType}
                            </>
                            :
                            displayListType
                        }
                    </Box>
                    </Grid>
                    {
                        toggleSidePanel &&
                        <Grid item xs={12} md={3} >
                            <BaseSidePanel
                                meta={meta} 
                                hideDetail={this.hideDetail}
                                doc={sidePanelDetail}
                                onDelete={this.onDelete}
                                onEdit={this.onEdit}
                                lang = {lang}
                            />
                        </Grid> 
                    }
                </Grid>
            </Grid>;
        const formComp =  
                    <BaseForm  meta={meta}
                            openSnackbar={openSnackbar}
                            lang = {lang}
                            row={currentRow}
                            rowId={currentRowId}
                            hideForm={this.hideForm}
                            user={user}
                            onlyForm={onlyForm}
                            selectInputItems={selectInputItems}
                            handleRefresh={(e)=> {this.refresh()}} />
                    

        const drawerComp = <Drawer anchor="right" open={formShown}>
            {formComp}
        </Drawer>
        return (
            <React.Fragment>
                {
                    onlyForm ? <Box mb={12}>
                        <Grid container>
                            <Grid item xs={12}>
                                {toolbarComp}
                                <Divider className={classes.divider} />
                            </Grid>
                            <Grid item xs={12}>
                                <Box>
                                    {formComp}
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                        :
                        <Box>
                            {isCsvUploading && <Box display="flex" alignItems="center" pl={8} pr={8}>
                                <Box width="100%" mr={1}>
                                    <LinearProgress variant="determinate" value={csvUploadingProgress} />
                                </Box>
                                <Box minWidth={100}>
                                    <Typography variant="body2" color="textSecondary">
                                        {`${Math.round(csvUploadingProgress)}%`}  ( {csvUploadingCount} / {csvUploadingCountTotal} )
                                    </Typography>
                                </Box>
                            </Box>}
                            {loading ? <Loader /> : drawerComp}
                            
                                {gridComp}
                            
                        </Box>
                }
            </React.Fragment>
        );
    }


}

BasePage.propTypes = {
    user: PropTypes.object,
    roles: PropTypes.array,
    theme: PropTypes.object
};

export default withRouter(withStyles(styles)(BasePage));
